var _defs, _rect, _circle, _circle2, _g, _circle3, _g2, _rect2, _polygon, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroAbstract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 340",
    width: 300,
    height: 340,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4bd5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2c1c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f38"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "orb",
    cx: 0.35,
    cy: 0.35,
    r: 0.65
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4bd5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c1c6c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wave",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4bd5ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4bd5ff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4bd5ff",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 340,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 70,
    r: 90,
    fill: "#1f1f38",
    opacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 300,
    r: 110,
    fill: "#4bd5ff",
    opacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.18,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 170,
    r: 70
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 170,
    r: 95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 170,
    r: 120
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 170,
    r: 145
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 170,
    r: 58,
    fill: "url(#orb)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#wave)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 250 C 60 215, 110 285, 170 250 S 260 215, 300 245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 268 C 60 233, 110 303, 170 268 S 260 233, 300 263",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 286 C 60 251, 110 321, 170 286 S 260 251, 300 281",
    strokeOpacity: 0.35
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 44,
    width: 46,
    height: 46,
    rx: 10,
    fill: "none",
    stroke: "#4bd5ff",
    strokeWidth: 2,
    transform: "rotate(18 59 67)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "245,205 270,250 220,250",
    fill: "#ffffff",
    fillOpacity: 0.15
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 160,
    r: 2,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 150,
    r: 2.5,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 40,
    r: 1.5,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 70,
    r: 1.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 300,
    r: 2,
    opacity: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroAbstract);
export default __webpack_public_path__ + "static/media/hero-abstract.5c7f43e05418cd71f6d72437db4e7cb2.svg";
export { ForwardRef as ReactComponent };